import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import FotonHub from './views/foton-hub'
import RPFS from './views/rpfs'
import AssetsImg from './views/assets-img'
import Contact from './views/contact'
import RadixWalletRedo from './views/radix-wallet-redo'
import Tickers from './views/tickers'
import Dexter from './views/dexter'
import Foton from './views/foton'
import Snapframe from './views/snapframe'
import Services from './views/services'
import RadixStream from './views/radix-stream'
import About from './views/about'
import Work from './views/work'
import RadixDLT from './views/radix-dlt'
import IrreversibleHomepage from './views/irreversible-homepage'
import NotFound from './views/not-found'
import ScrollToTop from './components/scroll-to-top'

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route component={FotonHub} exact path="/foton-hub" />
        <Route component={RPFS} exact path="/rpfs" />
        <Route component={AssetsImg} exact path="/assets-img" />
        <Route component={Contact} exact path="/contact" />
        <Route component={RadixWalletRedo} exact path="/radix-wallet-redo" />
        <Route component={Tickers} exact path="/tickers" />
        <Route component={Dexter} exact path="/dexter" />
        <Route component={Foton} exact path="/foton" />
        <Route component={Snapframe} exact path="/snapframe" />
        <Route component={Services} exact path="/services" />
        <Route component={RadixStream} exact path="/radix-stream" />
        <Route component={About} exact path="/about" />
        <Route component={Work} exact path="/work" />
        <Route component={RadixDLT} exact path="/radix-dlt" />
        <Route component={IrreversibleHomepage} exact path="/" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
